import type { SubTemplateProps } from '@/deskUiSkeletons/rowTemplates/RowTemplateTypes'

export function HackernewsCommentTemplate({ display, controls, slots }: SubTemplateProps) {
  const author = display.identity.author || display.identity.address || display.title || 'Anonymous'
  const initial = author.trim().slice(0, 1).toUpperCase() || '?'

  return (
    <article className={`md-hackernews-comment rounded-xl border border-slate-200 bg-white p-3${display.isChecked ? ' ring-2 ring-violet-400' : ''}`} data-md-sub-template="comments">
      <div className="flex gap-3">
        <div className="relative flex h-9 w-9 flex-none items-center justify-center overflow-hidden rounded-full bg-violet-600 text-xs font-semibold text-white">
          {initial}
          {display.media.avatarPath ? <img className="absolute inset-0 h-full w-full object-cover" src={display.media.avatarPath} alt="" /> : null}
        </div>
        <div className="min-w-0 flex-1">
          <header className="flex min-w-0 items-start justify-between gap-2">
            <strong className="min-w-0 break-words text-sm text-slate-900">{author}</strong>
            {controls.content.time}
          </header>
          <div className="mt-2 break-words [&_.md-sub-text]:whitespace-normal">{controls.content.text}</div>
          {display.permissions.canViewContent && !display.access.isContentLocked && display.media.attachments.length ? (
            <div className="mt-3 flex flex-wrap gap-2">
              {display.media.attachments.map((attachment, index) => {
                const label = attachment.title || attachment.filename || attachment.storedName || 'Attachment'
                return attachment.src ? (
                  <a key={`${attachment.id}-${index}`} className="rounded-lg bg-slate-100 px-2 py-1 text-xs font-medium text-violet-700" href={attachment.src}>{label}</a>
                ) : (
                  <span key={`${attachment.id}-${index}`} className="rounded-lg bg-slate-100 px-2 py-1 text-xs text-slate-600">{label}</span>
                )
              })}
            </div>
          ) : null}
          <footer className="mt-3 flex flex-wrap items-center gap-2 [&_.md-sub-icon]:h-6 [&_.md-sub-icon]:w-6">
            {controls.actions.quickReply}
            {controls.actions.favorite}
            {controls.links.answers}
            {controls.links.submsges}
          </footer>
        </div>
      </div>
      {slots.allChildren ? <div className="ml-6 mt-3 border-l border-violet-100 pl-3">{slots.allChildren}</div> : null}
    </article>
  )
}
